/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
/// ACTIONS ///
import { updateShopOutsideRadiusCorner } from "api/actions/price_list";
/// TYPES ///
import { IOutsideRadiusCorner } from "api/types/price_list/corner/outside_radius";
/// COMPONENTS ///
import PriceRow from "../../row";
/// VALUES ///
import { getMaterialHeightDisplay } from "values/material";

interface Props {
  index: number,
  last: boolean,
  outside_radius_corner: IOutsideRadiusCorner
}

export default function OutsideRadiusCorner({ index, last, outside_radius_corner }: Props) {
  const dispatch = useAppDispatch();

  return (
    <PriceRow
      index={index}
      last={last}
      original_price={outside_radius_corner?.price ?? 0}
      title={getMaterialHeightDisplay(outside_radius_corner?.material_thickness ?? "")}
      end_text="$"
      end_padding="45px"
      update={price => dispatch(updateShopOutsideRadiusCorner({ price: price }, outside_radius_corner.id))} />
  )
}
